(function () {
  const HIDE_CLASS = "tr-hide-variant-media";
  const MAP_SCRIPT_ID = "tr-variant-media-map";
  const STYLE_ID = "tr-variant-media-style";

  // Only run on product pages where the map exists
  if (!document.getElementById(MAP_SCRIPT_ID)) return;

  // ---------------------------
  // 1) Add CSS once
  // ---------------------------
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `.${HIDE_CLASS}{display:none!important;}`;
    document.head.appendChild(style);
  }

  // ---------------------------
  // 2) Helpers: data + variant
  // ---------------------------
  function getMapData() {
    const el = document.getElementById(MAP_SCRIPT_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return null;
    }
  }

  function getVariantIdFromUrl() {
    const v = new URLSearchParams(location.search).get("variant");
    return v ? String(v) : null;
  }

  function getVariantIdFromCurrentJson() {
    const vEl = document.querySelector("[data-current-variant-json]");
    if (!vEl) return null;
    try {
      const v = JSON.parse(vEl.textContent || "{}");
      return v?.id ? String(v.id) : null;
    } catch {
      return null;
    }
  }

  function getVariantIdFromFormInput() {
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return idInput?.value ? String(idInput.value) : null;
  }

  // Prefer URL variant because it updates immediately on swatch click
  function getCurrentVariantId() {
    return getVariantIdFromUrl() || getVariantIdFromCurrentJson() || getVariantIdFromFormInput();
  }

  function normSlug(s) {
    return String(s || "")
      .trim()
      .toLowerCase()
      .replace(/_/g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  function matchesGroup(alt, group) {
    const a = normSlug(alt);
    const g = normSlug(group);
    if (!a || !g) return false;
    return a === g || a.includes(g);
  }

  // ---------------------------
  // 3) Find gallery root
  // ---------------------------
  function getGalleryRoot() {
    return (
      document.querySelector(
        ".product__photos, .product__media, .product__main-photos, [data-product-images], .product-section"
      ) || null
    );
  }

  // ---------------------------
  // 4) Hide/show by IMG ALT
  // ---------------------------
  function getCandidateWrappers(root) {
    const sels = [
      "[data-media-id]",
      "[data-thumb-id]",
      ".product__media-item",
      ".product__photo",
      ".product__slide",
      ".product-main-slide",
      ".slick-slide",
      ".swiper-slide",
      ".product__thumb-item"
    ].join(",");

    const nodes = [...root.querySelectorAll(sels)];

    const imgParents = [...root.querySelectorAll("img:not(.pswp__img)")].map((img) => {
      return (
        img.closest(
          ".product__thumb-item, .product__media-item, .product__photo, .product__slide, .product-main-slide, .slick-slide, .swiper-slide"
        ) || img.parentElement
      );
    });

    const set = new Set();
    nodes.forEach((n) => n && set.add(n));
    imgParents.forEach((n) => n && set.add(n));
    return [...set];
  }

  function wrapperAlt(wrapper) {
    const img = wrapper.querySelector?.("img[alt]:not(.pswp__img)") || null;
    return img ? img.getAttribute("alt") : "";
  }

  function wrapperSrc(wrapper) {
    const img = wrapper.querySelector?.("img[src]:not(.pswp__img)") || null;
    return img ? img.getAttribute("src") || "" : "";
  }

  function isBlankSpot(wrapper) {
    return wrapperSrc(wrapper).includes("blank-spot.jpg");
  }

  function clearHidden(root) {
    root.querySelectorAll("." + HIDE_CLASS).forEach((el) => el.classList.remove(HIDE_CLASS));
  }

  function applyFilter() {
    const data = getMapData();
    if (!data?.variants || !data?.media) return;

    const variantId = getCurrentVariantId();
    if (!variantId) return;

    const group = normSlug(data.variants[variantId]?.group);
    if (!group) return;

    const root = getGalleryRoot();
    if (!root) return;

    const matchingMediaCount = (data.media || []).filter((m) => normSlug(m.group) === group).length;
    if (matchingMediaCount === 0) return;

    clearHidden(root);

    const wrappers = getCandidateWrappers(root);
    wrappers.forEach((w) => {
      const alt = wrapperAlt(w);

      // Always hide the known blank placeholder media if it exists
      if (isBlankSpot(w)) {
        w.classList.add(HIDE_CLASS);
        return;
      }

      // Shared media with no alt stays visible
      if (!alt) return;

      // Shared media with all color alts stays visible
      const normAlt = normSlug(alt);
      const sharedGroups = [
        "blue-lagoon",
        "coastal-mist",
        "desert-oasis",
        "obsidian-peak",
        "red-rock"
      ];
      const isSharedMedia = sharedGroups.every((g) => normAlt.includes(g));

      if (isSharedMedia) {
        w.classList.remove(HIDE_CLASS);
        return;
      }

      const show = matchesGroup(alt, group);
      w.classList.toggle(HIDE_CLASS, !show);
    });

    // The first-load color rule from product-images.liquid is no longer needed
    document
      .querySelectorAll("style[data-tr-variant-media-initial]")
      .forEach((el) => el.remove());
  }

  // ---------------------------
  // 5) Scheduling (debounced)
  // ---------------------------
  let t = null;
  function scheduleApply(delay = 80) {
    if (t) clearTimeout(t);
    t = setTimeout(() => {
      requestAnimationFrame(() => requestAnimationFrame(applyFilter));
    }, delay);
  }

  // ---------------------------
  // 6) Debug helpers
  // ---------------------------
  window.TRVariantMedia = window.TRVariantMedia || {};
  window.TRVariantMedia.apply = () => applyFilter();
  window.TRVariantMedia.state = () => {
    const data = getMapData() || {};
    const variantId = getCurrentVariantId();
    const group = variantId ? normSlug(data?.variants?.[variantId]?.group) : "";
    const media = Array.isArray(data.media) ? data.media : [];
    const matchingMediaCount = group ? media.filter((m) => normSlug(m.group) === group).length : 0;
    return {
      urlVariant: getVariantIdFromUrl(),
      currentJsonVariant: (() => {
        const v = getVariantIdFromCurrentJson();
        return v ? Number(v) : null;
      })(),
      formVariant: getVariantIdFromFormInput() || "",
      variantId: variantId || "",
      group,
      mediaCount: media.length,
      matchingMediaCount,
      galleryRootFound: !!getGalleryRoot()
    };
  };

  // ---------------------------
  // 7) Listeners + URL change hook
  // ---------------------------
  document.addEventListener("DOMContentLoaded", () => scheduleApply(150));
  window.addEventListener("load", () => scheduleApply(150));

  document.addEventListener("change", () => scheduleApply(80));
  document.addEventListener("click", () => scheduleApply(120));
  window.addEventListener("popstate", () => scheduleApply(50));

  (function hookHistory() {
    const _push = history.pushState;
    const _replace = history.replaceState;

    history.pushState = function () {
      const ret = _push.apply(this, arguments);
      scheduleApply(30);
      return ret;
    };
    history.replaceState = function () {
      const ret = _replace.apply(this, arguments);
      scheduleApply(30);
      return ret;
    };
  })();

  const currentVariantEl = document.querySelector("[data-current-variant-json]");
  if (currentVariantEl) {
    const obsVariant = new MutationObserver(() => scheduleApply(60));
    obsVariant.observe(currentVariantEl, { childList: true, subtree: true, characterData: true });
  }

  const root = getGalleryRoot() || document.body;
  const obsGallery = new MutationObserver(() => scheduleApply(120));
  obsGallery.observe(root, { childList: true, subtree: true });

  // Run once immediately so the correct color shows on first load
  applyFilter();

  scheduleApply(200);
})();

/* ------------------------------------------------------------
   TR: Collection Color Facet = single-select (Shopify Taxonomy)
------------------------------------------------------------ */
(function () {
  const KEY = "filter.v.t.shopify.color-pattern";

  if (!location.pathname.includes("/collections/")) return;

  let suppress = false;

  function cleanupUrl() {
    const url = new URL(window.location.href);
    const values = url.searchParams.getAll(KEY);
    if (values.length <= 1) return;

    const keep = values[values.length - 1];
    url.searchParams.delete(KEY);
    url.searchParams.append(KEY, keep);

    if (url.toString() !== window.location.href) {
      window.location.replace(url.toString());
    }
  }

  function getFacetScope(el) {
    return (
      el.closest("#FacetFiltersForm") ||
      el.closest("facet-filters-form") ||
      el.closest(".facets") ||
      el.closest(".collection-sidebar") ||
      el.closest(".collection-filters") ||
      el.closest("form")
    );
  }

  document.addEventListener(
    "change",
    function (e) {
      if (suppress) return;

      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.type !== "checkbox") return;
      if (t.name !== KEY) return;
      if (!t.checked) return;

      const scope = getFacetScope(t);
      if (!scope) return;

      suppress = true;

      const boxes = [...scope.querySelectorAll(`input[type="checkbox"][name="${KEY}"]`)];
      boxes.forEach((cb) => {
        if (cb !== t && cb.checked) {
          cb.checked = false;
          cb.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      suppress = false;
      setTimeout(cleanupUrl, 80);
    },
    true
  );

  document.addEventListener("DOMContentLoaded", cleanupUrl);
  window.addEventListener("load", cleanupUrl);
})();
